import ConsumptionReport from '../components/ConsumptionReport';
import { actualConfig } from '../configs/actualConfig';

const ActualConsumption = ({ outlets }) => {
  return (
    <ConsumptionReport {...actualConfig} outlets={outlets} />
  );
};

export default ActualConsumption;
